export default __webpack_public_path__ + "static/ecobeer-d853e627f2da5411239d09dc48374132.jpg";